export default "data:text/javascript;base64,aW1wb3J0IFRQYXNzd29yZElucHV0IGZyb20gIi4vVFBhc3N3b3JkSW5wdXQudnVlIjsKCmV4cG9ydCBkZWZhdWx0IFRQYXNzd29yZElucHV0Owo="